import { useCallback } from "react";

import { ModalsContainer } from "../../components/ModalsContainer";
import { RouteSwapWarningModal } from "../../components/RouteSwapWarningModal";
import { RouteEditorModalState } from "../../RouteEditor.types";

export type RouteEditorEditModalsBlockProps = {
    modalState: RouteEditorModalState;
    isRouteSwapWarningOpen: boolean;
    onExitMultiSelectMode: () => void;
    onRefreshSchedules: () => Promise<void>;
    onSave: (force?: boolean) => Promise<void>;
    onSetModalState: (state: RouteEditorModalState) => void;
    onSetIsRouteSwapWarningOpen: (open: boolean) => void;
};

export const RouteEditorEditModalsBlock = ({
    modalState,
    isRouteSwapWarningOpen,
    onExitMultiSelectMode,
    onRefreshSchedules,
    onSave,
    onSetModalState,
    onSetIsRouteSwapWarningOpen,
}: RouteEditorEditModalsBlockProps) => {
    const handleAfterAction = useCallback(async () => {
        onExitMultiSelectMode();
        await onRefreshSchedules();
    }, [onExitMultiSelectMode, onRefreshSchedules]);

    const handleConfirmRouteSwap = useCallback(() => {
        onSetIsRouteSwapWarningOpen(false);
        void onSave(true);
    }, [onSave, onSetIsRouteSwapWarningOpen]);

    return (
        <>
            <ModalsContainer
                onClose={() => onSetModalState(null)}
                modalState={modalState}
                onAfterConfirm={handleAfterAction}
            />

            {isRouteSwapWarningOpen && (
                <RouteSwapWarningModal
                    onClose={() => onSetIsRouteSwapWarningOpen(false)}
                    onConfirm={handleConfirmRouteSwap}
                />
            )}
        </>
    );
};
